import styled from "styled-components";

export const ContainerRegistrations = styled.section`
  max-width: 100%;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #151515;
`;

export const ContentRegistrations = styled.div`
  width: 1200px;
  height: 100%;
  padding-top: 88px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;

  @media (max-width: 1250px) {
    width: 100%;
    padding: 20px 20px;
  }
`;

export const ContentTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 18px;

  span {
    font-size: 29px;
    font-weight: 600;
    font-family: "GothamPro", sans-serif;
    color: white;

    @media (max-width: 475px) {
      font-size: 20px;
    }
  }
`;

export const ContainerCards = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 55px;
  margin-bottom: 55px;

  @media (max-width: 1125px) {
    justify-items: center;
    gap: 10px;
    align-content: center;
  }

  @media (max-width: 760px) {
    display: flex;
    flex-direction: column;
  }

  @media (max-width: 475px) {
    margin-bottom: 0px;
  }
`;

export const IconRegistrations = styled.img`
  width: 45px;
  height: 37px;
`;

export const DescriptionRegistrations = styled.label`
  font-size: 24px;
  font-weight: 600;
  font-family: "GothamPro", sans-serif;
  color: white;
  width: 85%;
  text-align: center;
  margin-top: 55px;
  margin-bottom: 55px;

  span {
    color: #f3b000;
  }

  @media (max-width: 1200px) {
    font-size: 20px;
  }

  @media (max-width: 920px) {
    width: 100%;
  }

  @media (max-width: 475px) {
    font-size: 16px;
  }
`;

export const ContainerRegisteredButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 40px;

  div {
    width: 343px;

    .buttonTwo {
      font-size: 16px;
    }

    @media (max-width: 375px) {
      width: 100%;
    }
  }

  @media (max-width: 760px) {
    flex-direction: column;
    align-items: center;
  }
`;
